import * as types from "./actionTypes";

export function changeInput(input) {
  return { type: types.CHANGE_INPUT, input };
}
